/* Фирмена покана: музика и звук при отваряне.
   Същият механизъм като при сватбените покани (синтезирани тонове в браузъра, без аудиофайлове),
   с фирмени и празнични мелодии. Народните коледни песни са свободни от авторски права,
   а „Лаундж“ и „Парти“ са оригинални кратки мотиви. */
(function () {
  'use strict';
  var html = document.documentElement;
  var ticket = document.getElementById('ticket');
  var openButton = document.getElementById('open');
  if (!ticket || !openButton) return;
  var M = globalThis.CORPORATE_MODEL;

  var T = {
    bg: {
      title: 'Музика и звук при отваряне', melody: 'Мелодия', sound: 'Звук при отваряне', volume: 'Сила на звука',
      listen: 'Прослушайте', stop: 'Спрете звука', on: '♪ Включете звука', off: '♪ Спрете звука',
      help: 'Гостът включва музиката с бутона долу вдясно. Ако в настройките изберете автоматичен звук, тя започва сама при отваряне.',
      melodies: { lounge: 'Лаундж джаз (спокойна вечер)', disco: 'Парти грув (за дансинга)', jingle: 'Jingle Bells (Коледа)', merry: 'We Wish You a Merry Christmas', auld: 'Auld Lang Syne (Нова година)', off: 'Без музика' },
      sounds: { clink: 'Звън на чаши', fanfare: 'Кратки фанфари', sparkle: 'Искрящо арпежио', off: 'Без ефект' }
    },
    en: {
      title: 'Music and opening sound', melody: 'Melody', sound: 'Opening sound', volume: 'Volume',
      listen: 'Listen', stop: 'Stop sound', on: '♪ Sound on', off: '♪ Sound off',
      help: 'Guests turn the music on with the button at the bottom right. If you choose automatic sound in the settings, it starts when the ticket opens.',
      melodies: { lounge: 'Lounge jazz (relaxed evening)', disco: 'Party groove (dance floor)', jingle: 'Jingle Bells (Christmas)', merry: 'We Wish You a Merry Christmas', auld: 'Auld Lang Syne (New Year)', off: 'No music' },
      sounds: { clink: 'Glasses clinking', fanfare: 'Short fanfare', sparkle: 'Sparkling arpeggio', off: 'No effect' }
    }
  };
  function ui() { return document.getElementById('enLang') && document.getElementById('enLang').getAttribute('aria-pressed') === 'true' ? 'en' : 'bg'; }
  function t(key) { return T[ui()][key]; }
  function settings() {
    return {
      melody: html.dataset.corporateMelody || 'lounge',
      openingSound: html.dataset.corporateSound || 'clink',
      audioVolume: Math.max(0, Math.min(0.5, Number(html.dataset.corporateVolume || 0.22)))
    };
  }

  // Звуков двигател
  var ctx = null, master = null, loop = null, running = false, step = 0, voices = new Set();
  function init() {
    var Audio = window.AudioContext || window.webkitAudioContext;
    if (!Audio) return false;
    if (!ctx) {
      ctx = new Audio();
      master = ctx.createGain();
      master.connect(ctx.destination);
    }
    master.gain.setTargetAtTime(settings().audioVolume, ctx.currentTime, 0.15);
    if (ctx.resume) ctx.resume().catch(function () {});
    return true;
  }
  function tone(freq, start, length, level, type) {
    if (!ctx || !master) return;
    var o = ctx.createOscillator(), g = ctx.createGain(), at = ctx.currentTime + start;
    o.type = type || 'sine';
    o.frequency.setValueAtTime(freq, at);
    g.gain.setValueAtTime(0.0001, at);
    g.gain.exponentialRampToValueAtTime(Math.max(0.001, level), at + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, at + length);
    o.connect(g); g.connect(master);
    voices.add(o);
    o.onended = function () { voices.delete(o); o.disconnect(); g.disconnect(); };
    o.start(at); o.stop(at + length + 0.05);
  }
  function midi(n) { return 440 * Math.pow(2, (n - 69) / 12); }

  function openingSound() {
    var s = settings().openingSound;
    if (s === 'off' || !init()) return;
    if (s === 'clink') {
      [2093, 2637, 3136].forEach(function (f, i) { tone(f, i * 0.11, 1.4, 0.07); tone(f * 1.5, i * 0.11, 0.6, 0.02); });
      [1975.5, 2489].forEach(function (f, i) { tone(f, 0.45 + i * 0.09, 1.2, 0.05); });
    } else if (s === 'fanfare') {
      [[67, 0, 0.18], [67, 0.2, 0.18], [72, 0.4, 0.7], [76, 0.4, 0.7], [79, 0.4, 0.9]].forEach(function (n) { tone(midi(n[0]), n[1], n[2], 0.07, 'sawtooth'); tone(midi(n[0]), n[1], n[2], 0.06, 'triangle'); });
    } else {
      [392, 493.88, 587.33, 783.99, 987.77, 1174.66].forEach(function (f, i) { tone(f, i * 0.12, 1.4, 0.11); });
    }
  }

  // Мелодия: [нота, продължителност в осмини]; 0 = пауза. Акорди: по един на 4 осмини.
  var SONGS = {
    lounge: { tempo: 300, lead: 'triangle',
      score: [[72, 2], [0, 1], [70, 1], [67, 2], [63, 2], [65, 3], [67, 1], [0, 4], [74, 2], [0, 1], [72, 1], [70, 2], [67, 2], [65, 6], [0, 2]],
      chords: [[48, 55, 58, 62], [53, 57, 60, 63], [46, 53, 57, 60], [51, 55, 58, 62]], bass: true, swing: true },
    disco: { tempo: 220, lead: 'square',
      score: [[69, 1], [72, 1], [76, 2], [74, 1], [72, 1], [69, 2], [67, 1], [69, 1], [72, 2], [0, 4], [69, 1], [72, 1], [76, 2], [79, 2], [77, 1], [76, 1], [74, 2], [0, 4]],
      chords: [[57, 60, 64], [53, 57, 60], [55, 59, 62], [52, 56, 59]], bass: true, beat: true },
    jingle: { tempo: 260, lead: 'triangle',
      score: [[76, 2], [76, 2], [76, 4], [76, 2], [76, 2], [76, 4], [76, 2], [79, 2], [72, 3], [74, 1], [76, 8], [77, 2], [77, 2], [77, 3], [77, 1], [77, 2], [76, 2], [76, 2], [76, 1], [76, 1], [76, 2], [74, 2], [74, 2], [76, 2], [74, 4], [79, 4]],
      chords: [[48, 52, 55], [48, 52, 55], [48, 52, 55], [48, 52, 55], [53, 57, 60], [48, 52, 55], [50, 55, 59], [55, 59, 62]], bells: true },
    merry: { tempo: 300, lead: 'triangle',
      score: [[67, 2], [72, 2], [72, 1], [74, 1], [72, 1], [71, 1], [69, 2], [69, 2], [69, 2], [74, 2], [74, 1], [76, 1], [74, 1], [72, 1], [71, 2], [67, 2], [67, 2], [76, 2], [76, 1], [77, 1], [76, 1], [74, 1], [72, 2], [69, 2], [67, 1], [67, 1], [69, 2], [74, 2], [71, 2], [72, 6]],
      chords: [[48, 52, 55], [53, 57, 60], [50, 53, 57], [55, 59, 62], [52, 55, 59], [45, 48, 52], [53, 57, 60], [55, 59, 62]], bells: true, waltz: true },
    auld: { tempo: 340, lead: 'sine',
      score: [[60, 2], [65, 3], [65, 1], [65, 2], [69, 2], [67, 3], [65, 1], [67, 2], [69, 2], [65, 3], [65, 1], [69, 2], [72, 2], [74, 6], [0, 2]],
      chords: [[41, 45, 48], [41, 45, 48], [48, 52, 55], [48, 52, 55], [41, 45, 48], [46, 50, 53], [41, 45, 48], [46, 50, 53]], bass: true }
  };
  function tick() {
    var song = SONGS[settings().melody];
    if (!song) return;
    var beat = step++;
    var total = song.score.reduce(function (a, n) { return a + n[1]; }, 0);
    var position = beat % total, start = 0, eighth = song.tempo / 1000;
    for (var i = 0; i < song.score.length; i++) {
      var n = song.score[i];
      if (start === position) {
        if (n[0]) {
          tone(midi(n[0]), 0, Math.max(0.25, n[1] * eighth * 0.9), 0.12, song.lead === 'square' ? 'triangle' : song.lead);
          if (song.lead === 'square') tone(midi(n[0] + 12), 0, Math.max(0.15, n[1] * eighth * 0.5), 0.025, 'square');
          if (song.bells) tone(midi(n[0] + 24), 0, 0.5, 0.02);
        }
        break;
      }
      start += n[1];
    }
    var bar = Math.floor(beat / 4);
    var chord = song.chords[bar % song.chords.length];
    if (beat % 4 === 0) {
      chord.forEach(function (note, j) { tone(midi(note), j * 0.02, song.tempo * 4 / 1000, 0.03); });
      if (song.bass) tone(midi(chord[0] - 12), 0, song.tempo * 1.8 / 1000, 0.06, 'triangle');
    }
    if (song.bass && song.swing && beat % 4 === 2) tone(midi(chord[0] - 5), 0, song.tempo * 1.5 / 1000, 0.05, 'triangle');
    if (song.beat) {
      if (beat % 2 === 0) tone(60, 0, 0.18, 0.12, 'sine');
      if (beat % 2 === 1) tone(6000, 0, 0.04, 0.012, 'square');
      if (beat % 4 === 2) tone(midi(chord[0] - 12), 0, 0.2, 0.05, 'triangle');
    }
  }

  var toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'fm-audio-toggle';
  toggle.hidden = true;
  document.body.appendChild(toggle);
  function updateToggle() {
    toggle.textContent = running ? t('off') : t('on');
    toggle.setAttribute('aria-pressed', running ? 'true' : 'false');
  }
  function start(withEffect) {
    stop(false);
    try {
      if (!init()) return;
      if (withEffect) openingSound();
      var s = settings();
      step = 0;
      if (s.melody !== 'off' && SONGS[s.melody]) {
        running = true;
        tick();
        loop = setInterval(tick, SONGS[s.melody].tempo);
      } else running = s.openingSound !== 'off';
      if (s.melody !== 'off' || s.openingSound !== 'off') toggle.hidden = false;
      updateToggle();
    } catch (e) { stop(); }
  }
  function stop(update) {
    clearInterval(loop); loop = null;
    voices.forEach(function (o) { try { o.stop(); } catch (e) {} });
    voices.clear();
    running = false;
    if (update !== false) updateToggle();
  }
  toggle.addEventListener('click', function () { if (running) stop(); else start(false); });

  // Звукът тръгва с отварянето на поканата (действие на госта)
  // По подразбиране без звук (поканата често се отваря в офиса); гостът го включва с бутона
  openButton.addEventListener('click', function () {
    if (html.dataset.corporateAuto === '1') { start(true); return; }
    var s = settings();
    if (s.melody !== 'off' || s.openingSound !== 'off') { toggle.hidden = false; updateToggle(); }
  });
  // Отключване на звука при първото докосване (нужно за телефони)
  document.addEventListener('pointerdown', function unlock() { init(); document.removeEventListener('pointerdown', unlock); }, { once: true });
  addEventListener('pagehide', function () { stop(false); });
  document.addEventListener('visibilitychange', function () { if (document.hidden && running) stop(); });

  // Настройки за организатора под билета (скрити в изгледа за гости)
  var picker = document.querySelector('.ticket-designs');
  var box = document.createElement('div');
  box.className = 'fm-audio-settings';
  if (picker) picker.appendChild(box); else ticket.parentNode.insertBefore(box, ticket.nextSibling);
  function options(list, labels, value) {
    return list.map(function (v) { return '<option value="' + v + '"' + (v === value ? ' selected' : '') + '>' + labels[v] + '</option>'; }).join('');
  }
  function draw() {
    var s = settings();
    var melodies = M ? M.melodies : Object.keys(T.bg.melodies);
    var sounds = M ? M.openingSounds : Object.keys(T.bg.sounds);
    box.innerHTML = '<p class="fm-audio-title">' + t('title') + '</p>' +
      '<label>' + t('melody') + '<select data-audio="melody">' + options(melodies, t('melodies'), s.melody) + '</select></label>' +
      '<label>' + t('sound') + '<select data-audio="openingSound">' + options(sounds, t('sounds'), s.openingSound) + '</select></label>' +
      '<label>' + t('volume') + '<input data-audio="audioVolume" type="range" min="0" max="0.5" step="0.01" value="' + s.audioVolume + '"></label>' +
      '<div class="fm-audio-buttons"><button type="button" data-audio-act="listen">▶ ' + t('listen') + '</button><button type="button" data-audio-act="stop">■ ' + t('stop') + '</button></div>' +
      '<p class="fm-audio-help">' + t('help') + '</p>';
  }
  box.addEventListener('change', function (e) {
    var key = e.target.dataset.audio;
    if (!key) return;
    var detail = {};
    detail[key] = key === 'audioVolume' ? Number(e.target.value) : e.target.value;
    document.dispatchEvent(new CustomEvent('corporate-audio', { detail: detail }));
    setTimeout(function () { if (running) start(false); }, 30);
  });
  box.addEventListener('input', function (e) {
    if (e.target.dataset.audio === 'audioVolume' && master && ctx) master.gain.setTargetAtTime(Number(e.target.value), ctx.currentTime, 0.05);
  });
  box.addEventListener('click', function (e) {
    var b = e.target.closest('[data-audio-act]');
    if (!b) return;
    if (b.dataset.audioAct === 'listen') start(true); else stop();
  });
  draw();
  ['bgLang', 'enLang'].forEach(function (id) {
    var b = document.getElementById(id);
    if (b) b.addEventListener('click', function () { setTimeout(function () { draw(); updateToggle(); }, 0); });
  });
  new MutationObserver(function () { if (!box.contains(document.activeElement)) draw(); }).observe(html, { attributes: true, attributeFilter: ['data-corporate-melody', 'data-corporate-sound'] });
})();
